module.exports = __webpack_public_path__ + "static/media/organizer_7.22781c8b.jpg";